// Import model
import { DataviewFpRoomResponse } from '../models/DataviewFpRoomResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterFpRoomRequest } from '../models/FilterFpRoomRequest';
import { FpRoom } from '../models/FpRoom';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterFpRoomRequestSerializer } from './FilterFpRoomRequestSerializer';
import { FpRoomSerializer } from './FpRoomSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewFpRoomResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewFpRoomResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewFpRoomResponse instance
   */
  static deserialize(json: string): DataviewFpRoomResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewFpRoomResponse instance
   */
  static fromObject(obj: any): DataviewFpRoomResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewFpRoomResponse');
    }


    const instance: DataviewFpRoomResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        FpRoomSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterFpRoomRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewFpRoomResponse instances
   */
  static deserializeArray(json: string): DataviewFpRoomResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewFpRoomResponse instance to a JSON string
   */
  static serialize(instance: DataviewFpRoomResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewFpRoomResponse instance to a plain object
   */
  static toObject(instance: DataviewFpRoomResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        FpRoomSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterFpRoomRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewFpRoomResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewFpRoomResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
